export default __webpack_public_path__ + "static/media/portfolio1.60ef18ce.png";